import { format as formatTz } from 'date-fns-tz';
import * as DateUtils from '../DateUtils';
export const getDaysOfOperation = daysOfWeek => DateUtils.toWeekdayRanges(daysOfWeek).join(', ');
export const getHoursOfOperation = options => {
  const {
    isAvailable24Hours,
    startTime = null,
    endTime = null
  } = options;
  if (isAvailable24Hours || !startTime || !endTime || startTime === endTime) {
    return '24hrs';
  }
  return [DateUtils.to12HourFormat(startTime), DateUtils.to12HourFormat(endTime)].join(' - ');
};
export const getTimezoneOfOperation = timezone => formatTz(new Date(), 'zzz', {
  timeZone: timezone
});
export const humanizeSupportTimings = availability => {
  const {
    daysOfWeek,
    startTime,
    endTime,
    isAvailable24Hours,
    timezone
  } = availability;
  if (!(daysOfWeek !== null && daysOfWeek !== void 0 && daysOfWeek.length)) return null;
  const supportDays = getDaysOfOperation(daysOfWeek);
  const supportHours = getHoursOfOperation({
    isAvailable24Hours,
    startTime,
    endTime
  });
  const supportTimezone = getTimezoneOfOperation(timezone);
  return [supportDays, supportHours, supportTimezone].join(' ');
};